import ProductPageLayout from "@/components/ProductPageLayout";
import rullaverho from "@/assets/rullaverho.png?format=webp&w=800";

const RollerBlindInstallation = () => (
  <ProductPageLayout title="Roller blind installation" metaDescription="Roller blind installation in Central Uusimaa. Blackout and light-filtering roller blinds." image={rullaverho} partner="osio" path="/en/roller-blind-installation" alternatePath="/rullaverho-asennus">
    <p className="text-muted-foreground leading-relaxed">
      Roller blinds are a modern and stylish window covering solution. They're suitable for both homes and 
      office spaces. Choose blackout, light-filtering or sheer fabric to suit your needs.
    </p>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Benefits of roller blinds</h2>
    <ul className="space-y-2 text-muted-foreground">
      <li>✓ Minimalist and clean appearance</li>
      <li>✓ Easy to use – chain or spring mechanism</li>
      <li>✓ Wide fabric and colour selection</li>
      <li>✓ Motorized versions also available</li>
    </ul>
    <p className="text-muted-foreground mt-6 leading-relaxed">
      We install roller blinds across the Central Uusimaa region: Hyvinkää, Järvenpää, Kerava, Mäntsälä, Nurmijärvi, Pornainen and Tuusula. 
      See <a href="https://osio.fi" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-foreground">Osio roller blinds</a>.
    </p>
  </ProductPageLayout>
);

export default RollerBlindInstallation;
